import { interviewType, notificationType } from '../../enums';

export default {
  namespaced: true,

  state: {
    activeInterviewType: interviewType.OFFICE_INTERVIEW,
    activeTab: 0,
    activeQuestion: 0,
    officeInterviewPlayerTime: 0,
    notificationType: notificationType.CANDIDATE_COMMON,
    frozenNeighbourIdsByVacancy: {},
    prefetchedAtLengthByVacancy: {},
  },

  mutations: {
    setFrozenNeighbourIds(state, { vacancyId, ids }) {
      if (!vacancyId) return;
      state.frozenNeighbourIdsByVacancy = {
        ...state.frozenNeighbourIdsByVacancy,
        [vacancyId]: ids && ids.length ? [...ids] : null,
      };
    },
    clearFrozenNeighbourIds(state, vacancyId) {
      if (!vacancyId) return;
      const next = { ...state.frozenNeighbourIdsByVacancy };
      delete next[vacancyId];
      state.frozenNeighbourIdsByVacancy = next;
      const nextLengths = { ...state.prefetchedAtLengthByVacancy };
      delete nextLengths[vacancyId];
      state.prefetchedAtLengthByVacancy = nextLengths;
    },
    setPrefetchedAtLength(state, { vacancyId, length }) {
      if (!vacancyId) return;
      state.prefetchedAtLengthByVacancy = {
        ...state.prefetchedAtLengthByVacancy,
        [vacancyId]: length,
      };
    },
    reset(state) {
      state.activeTab = 0;
      state.activeQuestion = 0;
      state.activeInterviewType = interviewType.OFFICE_INTERVIEW;
      state.officeInterviewPlayerTime = 0;
    },
    setActiveInterviewType(state, type) {
      state.activeInterviewType = type;
    },
    setActiveQuestion(state, question) {
      state.activeQuestion = question;
    },
    setActiveTab(state, tab) {
      state.activeTab = tab;
    },
    setOfficeInterviewPlayerTime(state, value) {
      state.officeInterviewPlayerTime = value;
    },
    setNotificationType(state, value) {
      state.notificationType = value;
    },
  },

  getters: {
    getFrozenNeighbourIds: (state) => (vacancyId) => state.frozenNeighbourIdsByVacancy[vacancyId] || null,
    getPrefetchedAtLength: (state) => (vacancyId) => state.prefetchedAtLengthByVacancy[vacancyId] || 0,
    activeTab(state) {
      return state.activeTab;
    },
    activeInterviewType(state) {
      return state.activeInterviewType;
    },
    activeQuestion(state) {
      return state.activeQuestion;
    },
    officeInterviewPlayerTime(state) {
      return state.officeInterviewPlayerTime;
    },
    notificationType(state) {
      return state.notificationType;
    },
  },
};
